import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-2 pb-0 g-0 row" }
const _hoisted_2 = { class: "col-12 col-md-6 g-0" }
const _hoisted_3 = { class: "offset-md-1 form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "medical-history" }, " Past Medical History ", -1 /* HOISTED */)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "resolved-problems" }, " Resolved Problems ", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "past-medical-comments" }, " Comments ", -1 /* HOISTED */)
const _hoisted_8 = { class: "offset-md-1 form-group" }
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "labs" }, " Labs ", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "This table contains documents labeled labs. To upload new labs, click Manage Documents.", -1 /* HOISTED */)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "scans-tests" }, " Scans/Tests ", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " This table contains documents labeled scans/tests. To upload new scans/tests, click Manage Documents. ", -1 /* HOISTED */)
const _hoisted_15 = { class: "col-12 col-md-6 g-0 form-group" }
const _hoisted_16 = { class: "offset-md-1" }
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 0,
  class: "shimmer-loading"
}
const _hoisted_19 = { class: "col-md-12 g-0" }
const _hoisted_20 = { class: "form-check custom-checkbox form-check-inline me-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "pediatric-visit"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Show Pediatric History Sections")
], -1 /* HOISTED */)
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PastDiagnosisHistory = _resolveComponent("PastDiagnosisHistory")!
  const _component_ProblemsTable = _resolveComponent("ProblemsTable")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_PatientDocuments = _resolveComponent("PatientDocuments")!
  const _component_HealthHistorySection = _resolveComponent("HealthHistorySection")!
  const _component_PediatricHistoryForm = _resolveComponent("PediatricHistoryForm")!
  const _component_FamilyHealthHistory = _resolveComponent("FamilyHealthHistory")!
  const _component_HospitalizationsTable = _resolveComponent("HospitalizationsTable")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Clinical History",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_PastDiagnosisHistory, {
              diagnosis: _ctx.patientDetails.healthHistory.pastMedicalHistories,
              "onUpdate:diagnosis": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.healthHistory.pastMedicalHistories) = $event))
            }, null, 8 /* PROPS */, ["diagnosis"]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_ProblemsTable, {
                problems: _ctx.patientDetails.healthHistory.resolvedProblems,
                "onUpdate:problems": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientDetails.healthHistory.resolvedProblems) = $event))
              }, null, 8 /* PROPS */, ["problems"]),
              _hoisted_7
            ]),
            _createVNode(_component_CommentInput, {
              "input-name": "past-medical-comments",
              placeholder: "Enter Comments",
              result: _ctx.patientDetails.healthHistory.pastMedicalHistoryComment,
              onResultUpdatedAppended: _ctx.medicalResultUpdatedAppended,
              onResultUpdated: _ctx.medicalResultUpdated,
              "patient-id": _ctx.patientId,
              "max-length": 5000,
              application: _ctx.application
            }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "patient-id", "application"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("button", {
                class: "btn btn-xs btn-outline-app-secondary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.manageDocuments()))
              }, " Manage Documents ")
            ]),
            _hoisted_11,
            _createVNode(_component_PatientDocuments, {
              "patient-id": _ctx.patientId,
              "delete-document": _ctx.deleteDocument,
              "get-documents": _ctx.getLabsDocuments,
              "is-history-page": true,
              "comment-document": _ctx.commentDocument,
              "is-loading-comment": _ctx.isLoadingComment,
              "provider-id": _ctx.patientOptions.data.providerId,
              application: _ctx.application,
              accountId: _ctx.accountId,
              documentType: "Labs"
            }, null, 8 /* PROPS */, ["patient-id", "delete-document", "get-documents", "comment-document", "is-loading-comment", "provider-id", "application", "accountId"]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createVNode(_component_PatientDocuments, {
                "patient-id": _ctx.patientId,
                "delete-document": _ctx.deleteDocument,
                "get-documents": _ctx.getScansDocuments,
                "is-history-page": true,
                "comment-document": _ctx.commentDocument,
                "is-loading-comment": _ctx.isLoadingComment,
                "provider-id": _ctx.patientOptions.data.providerId,
                application: _ctx.application,
                accountId: _ctx.accountId,
                documentType: "Scans/Tests"
              }, null, 8 /* PROPS */, ["patient-id", "delete-document", "get-documents", "comment-document", "is-loading-comment", "provider-id", "application", "accountId"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientDetails.healthHistory.patientClinicalHistories, (history, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("label", {
                for: `surgical-history-${history.type}`
              }, _toDisplayString(_ctx.historyType.getDescriptionUsingValue(history.type)), 9 /* TEXT, PROPS */, _hoisted_17),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                : (_openBlock(), _createBlock(_component_CommentInput, {
                    key: 1,
                    "input-name": `surgical-history-${history.type}`,
                    placeholder: `Enter ${_ctx.historyType.getDescriptionUsingValue(history.type)}`,
                    result: history.description,
                    "patient-id": _ctx.patientId,
                    onResultUpdatedAppended: (value)=>_ctx.resultUpdatedAppended(value,index),
                    onResultUpdated: (value)=>_ctx.resultUpdated(value,index),
                    "max-length": 5000,
                    application: _ctx.application
                  }, null, 8 /* PROPS */, ["input-name", "placeholder", "result", "patient-id", "onResultUpdatedAppended", "onResultUpdated", "application"]))
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _createVNode(_component_HealthHistorySection, {
            "patient-health-history": _ctx.patientDetails.healthHistory
          }, null, 8 /* PROPS */, ["patient-health-history"])
        ]),
        _createCommentVNode(" PEDIATRIC HISTORY "),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "pediatric-visit",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientDetails.healthHistory.showPediatricHistory) = $event)),
              disabled: _ctx.isLoading,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleShowPediatricHistory()))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_21), [
              [_vModelCheckbox, _ctx.patientDetails.healthHistory.showPediatricHistory]
            ]),
            _hoisted_22
          ]),
          (_ctx.patientDetails.healthHistory.showPediatricHistory)
            ? (_openBlock(), _createBlock(_component_PediatricHistoryForm, {
                key: 0,
                patientHealthHistory: _ctx.patientDetails.healthHistory,
                isWeightImperial: _ctx.isWeightImperial,
                isLengthImperial: _ctx.isLengthImperial,
                isCircumferenceImperial: _ctx.isCircumferenceImperial,
                birthWeightLarge: _ctx.birthWeightLarge,
                birthWeightSmall: _ctx.birthWeightSmall
              }, null, 8 /* PROPS */, ["patientHealthHistory", "isWeightImperial", "isLengthImperial", "isCircumferenceImperial", "birthWeightLarge", "birthWeightSmall"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" FAMILY HEALTH HISTORY "),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_FamilyHealthHistory, {
            "patient-id": _ctx.patientId,
            accountId: _ctx.accountId,
            application: _ctx.application
          }, null, 8 /* PROPS */, ["patient-id", "accountId", "application"])
        ]),
        _createCommentVNode(" HOSPITALIZATIONS "),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_HospitalizationsTable, {
            "patient-id": _ctx.patientId,
            "provider-id": _ctx.patientOptions.data.providerId,
            accountId: _ctx.accountId
          }, null, 8 /* PROPS */, ["patient-id", "provider-id", "accountId"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}